import AttachmentPreview from "@/business/notify/AttachmentPreview";
import React from "react";
import { formatDate } from "%/date";
import { Button } from "@/Button";
import DateButton from "@/common/DateButton";
import MessageModal from "@/MessageModal";
import { Dialog } from "@/Dialog";
import { ValidateSelectList } from "@/SelectList";
import { ValidateTextarea } from "@/Textarea";
import { Controller } from "react-hook-form";
import { CalendarNew as CalendarComponent } from "@/CalendarNew";
import ActivityRadioNew from "./ActivityRadioNew";
import ToggleSwitch from "@/common/ToggleSwitch";
import { Divider } from "@/Divider";
import { useRouter } from "@tanstack/react-router";
import useNotifySendSavedInform from "^/business/notify/useNotifySendSavedInform"; // type GalleryImage,
import {
  canUseNativePhotoPicker,
  openNativePhotoPicker,
} from "%/nativePhotoPicker";
import {
  BusinessNoticeTempDetailResponse,
  type ActivityOption,
} from "~/types/common";
// const petList = [
//   { value: "owner1", label: "위탁사업자 이름" },
//   { value: "owner2", label: "위탁사업자 이름2" },
// ];

// 기본 갤러리 데이터 (API 호출 실패 시 사용)
// const defaultGalleryData: GalleryImage[] = [
//   {
//     ImgID: 1,
//     ImgURL: "https://images.unsplash.com/photo-1543466835-00a7907e9de1",
//   },
//   {
//     ImgID: 2,
//     ImgURL: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b",
//   },
// ];

const SendSavedInform = ({
  data,
  editMode = false,
}: {
  data: BusinessNoticeTempDetailResponse["data"];
  editMode?: boolean;
}) => {
  const router = useRouter();
  const {
    // 폼 관련
    formMethods: {
      handleSubmit,
      control,
      watch,
      formState: { isValid },
    },

    // 선택 목록 데이터
    selectListData,

    // noticeSendSubData 관련
    // noticeSendSubData,
    // setNoticeSendSubData,

    // 날짜 관련
    date,
    selectedDate,
    setSelectedDate,
    selectedImgDate,
    setSelectedImgDate,

    // 모달 관련
    calendarModal: { isOpenModal, clickModal, closeModal },
    imageModal: {
      isOpenModal: isOpenImageModal,
      clickModal: clickImageModal,
      closeModal: closeImageModal,
    },
    imgDateModal: {
      isOpenModal: isOpenImgDateModal,
      clickModal: clickImgDateModal,
      closeModal: closeImgDateModal,
    },

    // 이미지 관련
    selectedImages,
    modalSelectedImages,
    toggleImageSelection,
    removeSelectedImage,
    handleImgModal,
    addBridgeImages,

    // 앨범 관련
    albumData,
    fetchAlbumList,

    // 토글 관련
    isToggle,
    setIsToggle,
    isTimeToggle,
    handleTimeToggleChange,

    // 다이얼로그 관련
    showSuccessDialog,
    setShowSuccessDialog,
    successMessage,

    // 제출 관련
    bindSubmit,
    isSubmitting,

    // 유효성 검사 함수
    validateActivitySelections,
  } = useNotifySendSavedInform(data, editMode);
  console.log("=== SendSavedInform 디버깅 ===");
  console.log("selectListData 전체:", selectListData);
  console.log("selectListData.activities:", selectListData.activities);
  console.log(
    "selectListData.activities 길이:",
    selectListData.activities?.length
  );
  console.log("initData:", data);
  console.log("initData.activities:", data?.activities);
  console.log("watch() 결과:", watch());

  // 현재 폼 데이터 감시
  const currentFormData = watch();

  // 활동 선택 유효성 검사
  const isActivityValid = validateActivitySelections(currentFormData);

  // 전체 유효성 검사 (기존 isValid + 활동 선택 유효성)
  const isFormValid = isValid && isActivityValid;

  // 디버깅용 로그
  console.log("isValid:", isValid);
  console.log("isActivityValid:", isActivityValid);
  console.log("isFormValid:", isFormValid);
  console.log("isToggle:", isToggle);
  console.log("Activities 상세:", selectListData.activities);

  // noticeSendSubData 설정 (예시 데이터)
  // React.useEffect(() => {
  //   const exampleData = {
  //     companyList: [
  //       { companySeq: 86, companyName: "김현호1", ceoName: null },
  //       { companySeq: 86, companyName: "김현호1", ceoName: null },
  //       { companySeq: 86, companyName: "김현호1", ceoName: null },
  //       { companySeq: 86, companyName: "김현호1", ceoName: null },
  //       { companySeq: 93, companyName: "목동랜드", ceoName: null },
  //       { companySeq: 94, companyName: "목동랜드", ceoName: null },
  //       { companySeq: 94, companyName: "목동랜드", ceoName: null },
  //     ],
  //     pets: [
  //       {
  //         petSeq: 10,
  //         petName: "또치",
  //         fileUrl:
  //           "https://cdn.mungtoday.com/FILE_TYPE_PET_PHOTO/f1dd6a50-d68e-4bfa-b7f3-c4bd6dadaad4.jpg",
  //       },
  //       {
  //         petSeq: 37,
  //         petName: "테스트멍2",
  //         fileUrl:
  //           "https://cdn.mungtoday.com/FILE_TYPE_PET_PHOTO/f1dd6a50-d68e-4bfa-b7f3-c4bd6dadaad4.jpg",
  //       },
  //       {
  //         petSeq: 40,
  //         petName: "테스트멍",
  //         fileUrl:
  //           "https://cdn.mungtoday.com/FILE_TYPE_PHOTO_ALBUM/fba305f0-8b04-416d-9fa7-28a1aee7a95c.jpg",
  //       },
  //       {
  //         petSeq: 43,
  //         petName: "개개개",
  //         fileUrl:
  //           "https://cdn.mungtoday.com/FILE_TYPE_PHOTO_ALBUM/fba305f0-8b04-416d-9fa7-28a1aee7a95c.jpg",
  //       },
  //       {
  //         petSeq: 44,
  //         petName: "개개개1",
  //         fileUrl:
  //           "https://cdn.mungtoday.com/FILE_TYPE_PHOTO_ALBUM/fba305f0-8b04-416d-9fa7-28a1aee7a95c.jpg",
  //       },
  //     ],
  //   };
  //   setNoticeSendSubData(exampleData);
  // }, [setNoticeSendSubData]);
  return (
    <>
      <form className="flex-col flex-auto gap-1 px-5 pb-12 bg-[#F5F5F5] grid grid-cols-1 animate-fadeIn">
        <div className="mb-5 animate-slideInFromTop">
          <Controller
            name="recipient"
            control={control}
            rules={{ required: "필수 선택입니다." }}
            render={({ field }) => (
              <ValidateSelectList
                editable={!editMode}
                onChange={(selectedOption) => {
                  const value = selectedOption?.value || "";
                  field.onChange(value);
                }}
                label="수신"
                placeholder="반려견 이름 선택"
                options={
                  selectListData?.recipients?.map((recipient) => ({
                    value: recipient.petSeq.toString(),
                    label: recipient.petName,
                  })) || []
                }
                value={
                  field.value
                    ? selectListData?.recipients?.find(
                        (recipient) =>
                          recipient.petSeq.toString() === field.value
                      )
                      ? {
                          value: field.value,
                          label:
                            selectListData.recipients.find(
                              (recipient) =>
                                recipient.petSeq.toString() === field.value
                            )?.petName || "",
                        }
                      : null
                    : null
                }
              />
            )}
          />
          <div
            className={`my-5 animate-slideInFromTop ${editMode ? "hidden" : ""}`}
            style={{ animationDelay: "0.1s" }}
          >
            <div className="flex justify-between items-center mb-1">
              <p className="mb-2 text-sm font-medium">발송시간</p>
              <ToggleSwitch
                checked={isTimeToggle}
                onChange={handleTimeToggleChange}
              />
            </div>
            {isTimeToggle && (
              <div className="flex gap-1 items-center mb-1">
                <DateButton
                  value={selectedDate ? formatDate(selectedDate) : date}
                  onClick={() => clickModal()}
                />
                <Controller
                  name="hour"
                  control={control}
                  rules={{ required: "시간을 선택하세요" }}
                  render={({ field }) => {
                    const hourScalar =
                      typeof field.value === "string"
                        ? field.value
                        : (field.value as { value?: string })?.value ?? "";
                    return (
                      <ValidateSelectList
                        isDefaultValue={true}
                        placeholder="시"
                        isSearchable={false}
                        options={Array.from({ length: 24 }, (_, i) => ({
                          value: (i + 1).toString().padStart(2, "0"),
                          label: (i + 1).toString().padStart(2, "0"),
                        }))}
                        boxHeight={20}
                        className="h-10 text-lg text-center"
                        value={
                          hourScalar
                            ? { value: hourScalar, label: hourScalar }
                            : null
                        }
                        onChange={(option) =>
                          field.onChange(option?.value ?? "")
                        }
                      />
                    );
                  }}
                />
                <span className="text-[12px]">시</span>
                <Controller
                  name="minute"
                  control={control}
                  rules={{ required: "분을 선택하세요" }}
                  render={({ field }) => {
                    const minuteScalar =
                      typeof field.value === "string"
                        ? field.value
                        : (field.value as { value?: string })?.value ?? "";
                    return (
                      <ValidateSelectList
                        isDefaultValue={true}
                        placeholder="분"
                        isSearchable={false}
                        options={Array.from({ length: 6 }, (_, i) => ({
                          value: (i * 10).toString().padStart(2, "0"),
                          label: (i * 10).toString().padStart(2, "0"),
                        }))}
                        boxHeight={20}
                        className="h-10 text-lg text-center"
                        value={
                          minuteScalar
                            ? { value: minuteScalar, label: minuteScalar }
                            : null
                        }
                        onChange={(option) =>
                          field.onChange(option?.value ?? "")
                        }
                      />
                    );
                  }}
                />
                <span className="text-[12px]">분</span>
              </div>
            )}
          </div>
          <div
            className="my-5 animate-slideInFromTop"
            style={{ animationDelay: "0.2s" }}
          >
            <Controller
              name="content"
              control={control}
              rules={{ required: "필수 선택입니다." }}
              render={({ field }) => (
                <ValidateTextarea
                  {...field}
                  className="w-full h-100"
                  label="내용"
                  rows={10}
                />
              )}
            />
          </div>
          {/* 사진 등록 */}
          <div
            className="my-5 animate-slideInFromTop"
            style={{ animationDelay: "0.3s" }}
          >
            <p className="mb-2 text-sm font-medium">사진등록</p>
            <div className="flex justify-between">
              <div className="flex items-center mr-2">
                <DateButton
                  value={selectedImgDate ? formatDate(selectedImgDate) : date}
                  onClick={() => clickImgDateModal()}
                />
              </div>
              <button
                className="w-full bg-white rounded-md border border-gray-400 transition-all duration-300 hover:bg-gray-50 hover:border-gray-500 transform hover:scale-[1.02]"
                onClick={async (e) => {
                  e.preventDefault();
                  // 수신자가 선택되었는지 확인
                  const selectedRecipient = watch("recipient");
                  if (!selectedRecipient) {
                    alert("먼저 수신자를 선택해주세요.");
                    return;
                  }
                  // 앱(신버전) = 네이티브 통합 사진첩(스마트폰+클라우드, petSeq 스코프, 다중)
                  // 그 외(구버전 앱·브라우저) = 기존 웹 모달 폴백 (신규 발송 SendInform 과 동일)
                  if (canUseNativePhotoPicker()) {
                    try {
                      const picked = await openNativePhotoPicker({
                        petSeq: Number(selectedRecipient),
                        multiSelect: 300, // 대량 선택 허용(안드는 OS 상한까지)
                      });
                      if (picked.length) addBridgeImages(picked);
                    } catch (err) {
                      alert(
                        err instanceof Error
                          ? err.message
                          : "사진첩을 여는 데 실패했습니다.",
                      );
                    }
                    return;
                  }
                  // 앨범 목록 가져오기 (기존 웹 모달)
                  fetchAlbumList(selectedRecipient);
                  clickImageModal();
                }}
              >
                <p>사진 불러오기</p>
              </button>
            </div>
            {/* 선택된 사진 미리보기 */}
            <div className="flex flex-col gap-2 overflow-y-auto max-h-[500px] mt-3">
              <div className="grid grid-cols-4 gap-1 sm:grid-cols-4">
                {selectedImages.length > 0 &&
                  selectedImages[0].ImgURL &&
                  selectedImages.map((data) => {
                    return (
                      <div
                        key={data.ImgID}
                        className="relative cursor-pointer aspect-square"
                      >
                        <AttachmentPreview
                          fileSeq={data.ImgID}
                          originalUrl={data.ImgURL}
                          thumbnailUrl={data.thumbnailUrl}
                          thumbnailStatus={data.thumbnailStatus}
                        />
                        {/* X(삭제) 버튼 */}
                        <button
                          type="button"
                          className="flex absolute top-1 right-1 z-10 justify-center items-center w-4 h-4 text-xs bg-white bg-opacity-60 rounded-full hover:bg-opacity-90"
                          onClick={() => removeSelectedImage(data)}
                          style={{ lineHeight: 1 }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M4 4L12 12"
                              stroke="gray"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                            <path
                              d="M12 4L4 12"
                              stroke="gray"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {/* 오늘의 활동 */}
          <div
            className="my-5 animate-slideInFromTop"
            style={{ animationDelay: "0.4s" }}
          >
            <div className="flex justify-between items-center mb-1">
              <p className="text-sm font-medium">오늘의 활동</p>
              <ToggleSwitch
                checked={isToggle}
                onChange={(checked) => setIsToggle(checked)}
                // disabled={isUpdating}
              />
            </div>
            {isToggle && (
              <>
                <Divider className="mt-auto" line={true} />
                <div className="grid grid-cols-5 gap-x-2 gap-y-2 items-center my-3">
                  {/* 동적 활동 목록 - API에서 받아온 데이터 사용 */}
                  {selectListData?.activities &&
                  selectListData.activities.length > 0 ? (
                    selectListData.activities.map((item) => {
                      console.log(
                        "렌더링 중인 활동:",
                        item.cdActivity,
                        item.value,
                        item.activityValues
                      );
                      return (
                        <React.Fragment key={item.cdActivity}>
                          <div className="col-span-1 pr-2 text-sm text-left">
                            {item.value}
                          </div>
                          <Controller
                            name={item.cdActivity}
                            control={control}
                            render={({ field }) => (
                              <ActivityRadioNew
                                value={field.value as ActivityOption | null}
                                onChange={(value) => field.onChange(value)}
                                options={item.activityValues}
                                colorIdx={0}
                              />
                            )}
                          />
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <div className="col-span-5 py-4 text-center text-gray-500">
                      활동 데이터가 없습니다. selectListData.activities:{" "}
                      {JSON.stringify(selectListData?.activities)}
                    </div>
                  )}
                </div>
              </>
            )}
            <Divider className="mt-auto" line={true} />
          </div>
          {/* 오늘의 활동 끝 */}
        </div>
      </form>
      <div
        className="sticky bottom-14 w-full px-5 py-3 bg-[#F5F5F5] flex gap-2 animate-slideInFromTop"
        style={{ animationDelay: "0.5s" }}
      >
        {editMode ? (
          <Button
            className="w-full bg-[#F5F5F5]"
            style={{ pointerEvents: "auto" }}
            onClick={handleSubmit((data) => bindSubmit(data, false))}
            disabled={!isFormValid || isSubmitting}
          >
            <div className="py-3 mx-auto w-full font-semibold text-center text-white bg-orange-400 rounded-full text-[16px] transition-all duration-300 hover:bg-orange-500 transform hover:scale-[1.02]">
              {isSubmitting ? "수정 중..." : "수정 완료"}
            </div>
          </Button>
        ) : (
          <>
            <Button
              className="w-full bg-[#F5F5F5]"
              style={{ pointerEvents: "auto" }}
              onClick={handleSubmit((data) => bindSubmit(data, true))}
              disabled={!isFormValid || isSubmitting}
            >
              <div className="py-3 mx-auto w-full font-semibold text-center text-yellow-500 bg-white rounded-full border border-yellow text-[16px] text-yellow transition-all duration-300 hover:bg-yellow-50 hover:border-yellow-400 transform hover:scale-[1.02]">
                저장하기
              </div>
            </Button>
            <Button
              className="w-full bg-[#F5F5F5]"
              style={{ pointerEvents: "auto" }}
              onClick={handleSubmit((data) => bindSubmit(data, false))}
              disabled={!isFormValid || isSubmitting}
            >
              <div className="py-3 mx-auto w-full font-semibold text-center text-white bg-orange-400 rounded-full text-[16px] transition-all duration-300 hover:bg-orange-500 transform hover:scale-[1.02]">
                즉시 발송
              </div>
            </Button>
          </>
        )}
      </div>
      {/* 모달 영역 */}
      {/* 달력 모달 */}
      <MessageModal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none animate-scaleIn"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        shouldCloseOnOverlayClick={false}
      >
        <CalendarComponent
          disabled={false}
          disablePast={true}
          dayOnClick={(day) => {
            setSelectedDate(day);
          }}
          selectedDay={selectedDate}
          schedules={{}}
        />
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={closeModal}
          >
            확인
          </button>
        </div>
      </MessageModal>
      <MessageModal
        isOpen={isOpenImgDateModal}
        onRequestClose={closeImgDateModal}
        className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none animate-scaleIn"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        shouldCloseOnOverlayClick={false}
      >
        <CalendarComponent
          disabled={false}
          dayOnClick={(day) => {
            setSelectedImgDate(day);
          }}
          selectedDay={selectedImgDate}
          schedules={{}}
        />
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeImgDateModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={closeImgDateModal}
          >
            확인
          </button>
        </div>
      </MessageModal>
      {/* 달력 모달 */}
      <MessageModal
        isOpen={isOpenImageModal}
        onRequestClose={closeImageModal}
        className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none animate-scaleIn"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        shouldCloseOnOverlayClick={false}
      >
        <div className="flex flex-col gap-2 overflow-y-auto h-[500px]">
          <div className="grid grid-cols-4 gap-1 sm:grid-cols-4">
            {albumData.length > 0 &&
              albumData.map((data) => {
                return (
                  <div
                    key={data.ImgID}
                    className={`relative cursor-pointer aspect-square border-2 rounded-lg ${
                      modalSelectedImages?.find(
                        (item) => item.ImgID === data.ImgID
                      )
                        ? " border-orange-500"
                        : "border-white bg-white"
                    }`}
                    onClick={() => toggleImageSelection(data)}
                  >
                    <AttachmentPreview
                      fileSeq={data.ImgID}
                      originalUrl={data.ImgURL}
                      thumbnailUrl={data.thumbnailUrl}
                      thumbnailStatus={data.thumbnailStatus}
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeImageModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={handleImgModal}
          >
            선택
          </button>
        </div>
      </MessageModal>

      {/* 성공 다이얼로그 */}
      <Dialog
        visible={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
      >
        <div className="text-center">
          <h3 className="mb-2 text-lg font-semibold">{successMessage.title}</h3>
          <p className="mb-4 text-gray-600">{successMessage.message}</p>
          <button
            onClick={() => {
              setShowSuccessDialog(false);
              router.navigate({ to: "/business/layout/notify" });
            }}
            className="px-4 py-2 text-white bg-orange-400 rounded-lg hover:bg-orange-500"
          >
            확인
          </button>
        </div>
      </Dialog>
    </>
  );
};

export default SendSavedInform;
